import * as yup from 'yup';

const isNotFutureDate = value => {
  if (!value) {
    return true;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return true;
  }

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);
  return parsed <= endOfToday;
};

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      q: yup.string().nullable(),
      priorityCode: yup.string().nullable(),
      typeCode: yup.string().nullable(),
      statusCode: yup.string().nullable(),
      assigneeUserId: yup.string().nullable(),
      reporterUserId: yup.string().nullable(),
      companyId: yup.string().nullable(),
      reporterCompanyType: yup.string().nullable(),
      serviceAdministratorId: yup.string().nullable(),
      createdFrom: yup
        .string()
        .nullable()
        .test(
          'created-from-not-future',
          formatMessage({
            id: 'CREATED_FROM_CANNOT_BE_IN_THE_FUTURE',
            defaultMessage: 'Created From cannot be in the future',
          }),
          isNotFutureDate,
        ),
      createdTo: yup
        .string()
        .nullable()
        .test(
          'created-to-not-future',
          formatMessage({
            id: 'CREATED_TO_CANNOT_BE_IN_THE_FUTURE',
            defaultMessage: 'Created To cannot be in the future',
          }),
          isNotFutureDate,
        ),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
